import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-12',
  templateUrl: './12.component.html',
})
export class VbGeneral12Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
